import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import {
  clearClient,
  setClient,
  setClientID,
  setCompanyCode,
  setIsAdmin,
  setProjectID,
  setUser,
} from "../../../Redux/Actions/actions.js";
import { fetchAdminRows } from "../../Dashboard/Admin/AdminQueries/useAdminRows.jsx";
import { fetchClientRows } from "../../Dashboard/Client/ClientQueries/useClientRows.jsx";

// Check if the user is signed in function
export const checkSignIn = async (code) => {
  try {
    const res = await axios.get(`/api/client/sign-in/${code}/`, {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    console.error(err);
  }
};

// Custom hook to manually sign in the user
export default function useManualLogin(
  dispatch,
  user,
  enqueueSnackbar,
  navigate,
  queryClient,
) {
  const signIn = useMutation({
    mutationFn: (code) => checkSignIn(code),
    onSuccess: async (data) => {
      if (data.is_admin === true) {
        await queryClient.prefetchQuery({
          queryKey: ["adminRows"],
          queryFn: () => fetchAdminRows(true),
        });
        dispatch(setIsAdmin(true));
        dispatch(clearClient());
        dispatch(
          setUser({
            id: "argus_admin",
            companyCode: data.companyCode,
            name: "Argus Admin",
            email: "info@argusnv.com",
            phone: "702-468-6962",
            title: "Argus Admin",
            admin: true,
            currentClient: null,
            currentProject: null,
            hideArchived: false,
            archivedProjects: [],
          }),
        );

        enqueueSnackbar("Login Successful - Welcome Argus Admin", {
          variant: "success",
          autoHideDuration: 2500,
        });

        navigate("/dashboard/admin", { replace: true });
        return;
      }
      const clientData = data.client;
      const companyCode = data.companyCode;
      const clientId = clientData.id;
      console.log("CLIENT DATA: ", clientData);
      dispatch(setCompanyCode(companyCode));
      dispatch(setIsAdmin(false));
      dispatch(
        setClient({
          id: clientId,
          name: clientData.name,
          shortName: clientData.shortName,
          address: clientData.address,
          city: clientData.city,
          state: clientData.state,
          zip: clientData.zipCode,
          phone: clientData.phone,
          fax: clientData.fax,
          taxId: clientData.taxId,
        }),
      );
      dispatch(setClientID(clientId));
      dispatch(setProjectID(null));

      const isClientUser = user?.name && user.currentClient === clientId;
      const snackbarName = isClientUser ? user.name : clientData.name;

      enqueueSnackbar(`Login Successful - Welcome ${snackbarName}`, {
        variant: "success",
        autoHideDuration: 2500,
      });

      if (!isClientUser) {
        await queryClient.invalidateQueries({
          queryKey: ["clientRows", clientId],
          queryFn: () => fetchClientRows(clientId),
        });

        dispatch(
          setUser({
            id: null,
            companyCode: companyCode,
            name: "",
            email: "",
            phone: "",
            title: "",
            admin: false,
            currentClient: clientId,
            currentProject: null,
            savedProjects: [],
          }),
        );
      } else {
        await queryClient.invalidateQueries({
          queryKey: ["clientRows", clientId],
          queryFn: () => fetchClientRows(clientId, user.id),
        });
      }
      navigate(`/dashboard/client/${clientId}`, { replace: true });
    },
    onError: (error) => {
      enqueueSnackbar(`Unsuccessful sign in attempt`, {
        variant: "error",
      });
    },
  });

  return signIn;
}
